import {useState} from 'react';
import {useSelector} from 'react-redux';
import PlatformToggle from "../../../components/PlatformToggle";
import CustomCarousel from "../../dynamicUi/elements/carousel/CustomCarousel";
import {BANNER_TYPE} from "../../../constants/commons";
import CustomModal from "../../../components/CustomModal";

const BannerPreview = ({previewBanners, setPreviewBanners, allBanners = []}) => {

  const [mobileView, setMobileView] = useState(true);

  const {
    data: bannerData, selectedPage: selectedBannerType
  } = useSelector((state) => state.banner.pages);

  const activePage = bannerData.find((d) => d.id === selectedBannerType);

  return (
    <CustomModal
      title="Banners"
      bodyClasses={mobileView ? 'max-w-md' : 'max-w-6xl'}
      preFooterComponent={
        <PlatformToggle mobileView={mobileView} mobileOnClick={() => setMobileView(true)}
                        webOnClick={() => setMobileView(false)}/>}
      children={

        <CustomCarousel mobile={mobileView} showArrowButton={true} showDotIndicator={true} type={BANNER_TYPE.dynamic_banner} bannerList={{
          data: {data: allBanners, page_info: activePage},
          init: true
        }}/>

      }
      showModal={previewBanners} setShowModal={setPreviewBanners}
    />
  );
};

export default BannerPreview;
